import React from 'react'
import ContentLoader from 'react-content-loader'

const FulfilmentSkeleton = ({ speed = 2, primaryColor = '#f0f0f0', secondaryColor = '#e5e5e5' }) => (
  <div className='fulfilment-msg-panel'>
    <ContentLoader
      height={131}
      width={350}
      speed={speed}
      backgroundColor={primaryColor}
      foregroundColor={secondaryColor}
    >
      <rect x='0' y='10' rx='2' ry='2' width='155' height='25' />
      <rect x='0' y='45' rx='2' ry='2' width='350' height='40' />
      <rect x='0' y='95' rx='2' ry='2' width='350' height='35' />
    </ContentLoader>
  </div>
)
export default FulfilmentSkeleton
